import { NgModule } from '@angular/core';
import { AccountSubscriptionManagerModule } from './account-subscription-manager.module';
import { AccountSubscriptionManagerRoutingModule } from './account-subscription-manager.routing';

@NgModule({
    imports: [
        AccountSubscriptionManagerModule,
        AccountSubscriptionManagerRoutingModule
    ],
    declarations: [],
    exports: [],
    providers: []
})
export class AccountSubscriptionManagerRoutetownModule {}
